import React from 'react';  // eslint-disable-line

const Reset = (props) => {
    return (
        <svg data-qa={props.dataqa} onClick={props.reset} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <g fill="none" fillRule="evenodd" stroke="#444">
                <path d="M1.15 9A7.833 7.833 0 0 0 9 16.85 7.833 7.833 0 0 0 16.85 9 7.833 7.833 0 0 0 9 1.15c-3.14 0-5.977 1.933-7.185 4.65" />
                <path strokeLinecap="square" d="M1.277 1.652L1.815 5.8l4.153-.54" />
            </g>
        </svg>
    );
};

export default Reset;
